import { Injectable } from '@angular/core';
import { catchAndGetFromFailureRxOp } from '@geekbears/gb-ngrx-stack-base';
import { Actions, createEffect, EffectsModule, ofType } from '@ngrx/effects';
import { map, mergeMap, switchMap, withLatestFrom } from 'rxjs';

import { ProfileServices } from '../../domain/services';
import { ProfileActions } from './profile.actions';
import { Store } from '@ngrx/store';
import {
  authenticatedUserIdSelector,
  AuthenticationNgRxActions,
} from '@geekbears/gb-ngrx-auth-basic';

@Injectable()
export class ProfileEffects {
  constructor(
    private actions$: Actions,
    private profileService: ProfileServices,
    private store$: Store
  ) {}

  updateProfileData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProfileActions.updateProfileData),
      withLatestFrom(this.store$.select(authenticatedUserIdSelector)),
      switchMap(([action, userId]) => {
        return this.profileService.updateProfileData(action.data, userId!).pipe(
          map((response) =>
            ProfileActions.updateProfileDataSuccess({ response })
          ),
          catchAndGetFromFailureRxOp((failure) =>
            ProfileActions.updateProfileDataFailure({ failure })
          )
        );
      })
    );
  });

  updatePassword$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProfileActions.updatePassword),
      withLatestFrom(this.store$.select(authenticatedUserIdSelector)),
      mergeMap(([action, userId]) => {
        return this.profileService
          .updatePassword({
            ...action.userData,
            userId: userId!,
          })
          .pipe(
            map((response) =>
              ProfileActions.updatePasswordSuccess({ response })
            ),
            catchAndGetFromFailureRxOp((failure) =>
              ProfileActions.updatePasswordFailure({ failure })
            )
          );
      })
    );
  });

  updatePhoto$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProfileActions.updatePhoto),
      withLatestFrom(this.store$.select(authenticatedUserIdSelector)),
      switchMap(([action, userId]) => {
        return this.profileService.updatePhoto(action.photo, userId!).pipe(
          map((response) => ProfileActions.updatePhotoSuccess({ response })),
          catchAndGetFromFailureRxOp((failure) =>
            ProfileActions.updatePhotoFailure({ failure })
          )
        );
      })
    );
  });
  updatePhotoSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProfileActions.updatePhotoSuccess),
      switchMap(() => [AuthenticationNgRxActions.getAuthenticatedUserData()])
    )
  );
}
export const ProfileEffectsModule = EffectsModule.forFeature([ProfileEffects]);
